import { onInstallService } from './handlers/install'

// TODO - Split what is widtget, what is config slack
export const TWILIO_WIDGET = {
  id: 'TWILIO_INTEGRATION',
  type: 'TOKEN',
  name: 'Integração com twilio',
  description: 'Criar integração com o Twilio',
  color: 'light3',
  image: '/services/twilio.png',
  categories: ['Comunicação'],
  service: 'twilio',
  onClick: onInstallService,
  initialState: {
    name: 'Comunicação',
    data: {
      type: 'O_OUTH'
    }
  }
}
